import { cva } from 'class-variance-authority'

// Shared shell for text-input surfaces so composite fields (e.g. the DatePicker's
// segmented field) stay visually in step with `Input`.
//
// `focus` picks the selector that drives the ring: `visible` for a real <input>
// that takes focus itself, `within` for a wrapper whose focus lands on a child.
const inputVariants = cva(
  'border-border dark:bg-input/30 flex h-9 w-full min-w-0 rounded-md border bg-transparent px-3 py-1 text-base shadow-xs transition-[color,box-shadow] md:text-sm',
  {
    variants: {
      focus: {
        visible:
          'outline-none focus-visible:border-ring focus-visible:ring-ring/50 focus-visible:ring-[3px] aria-invalid:border-destructive aria-invalid:ring-destructive/20 dark:aria-invalid:ring-destructive/40',
        within:
          'items-center focus-within:border-ring focus-within:ring-ring/50 focus-within:ring-[3px] aria-invalid:border-destructive aria-invalid:focus-within:ring-destructive/20 dark:aria-invalid:focus-within:ring-destructive/40'
      }
    },
    defaultVariants: {
      focus: 'visible'
    }
  }
)

export { inputVariants }
